import Header from "../components/header";
import PageTitle from "../components/page-title";
import PageNavigator from "../components/page-navigator";
import Table from "../components/table";
import Holder from "../components/holder";
import InputModule from "../components/input-module";
import DeleteAccount from "../components/delete-account";
import { useState,useEffect } from "react";
import { fetchVoices } from "../functions/fetchVoices";
import { openSiteAdder } from "../functions/openInput";
import CustomPostModule from "../components/custom-post-module";
import { openCustomPostModule } from "../functions/openCustomPostModule";
import SettingsEditor from "../components/settings-editor";


function BillingPage(){
    const [inputOpen,setInputOpen] = useState(false);
    const [deleteAccountOpen,setDeleteAccountOpen] = useState(false);
    const [settingsEditorOpen,SetSettingsEditorOpen] = useState("none");
    const [context,SetContext] = useState(null);
    const [voices,setVoices] = useState(null)

    const handleClick = () => {
        openSiteAdder(setInputOpen,inputOpen);
    }

        const [customPostModuleOpen,setCustomPostModuleOpen] = useState(false);
    
        const handleClick2 = () =>{
            openCustomPostModule(setCustomPostModuleOpen,customPostModuleOpen)
        }

        const openSettingsModule = (context) => {
            SetContext(context);
            document.body.style.overflow = "hidden";        
            SetSettingsEditorOpen("flex");
        }

        const closeSettingsModule = () =>{
            document.body.style.overflow = "";        
            SetSettingsEditorOpen("none")
        }
    

    
    const openAccountDeletionPortal = () => {
        console.log("opening");
        setDeleteAccountOpen(true);
    }
 
    const closeAccountDeletionPortal = () => {
        console.log("closing")
        setDeleteAccountOpen(false);
    }

        useEffect(() => {
            const waitForData = async() => {
            await fetchVoices(setVoices);
            }
            waitForData();
          }, []);


    return <>
    <Header CTA='Add site' functionForButton={handleClick}></Header>    

    <Holder 
    left={<PageNavigator numberSelected={5}/>}
    right={<>
        <PageTitle text='Manage your billing and account settings.' heading='Your account settings'></PageTitle>
        <Table openSettings={openSettingsModule} openAccountDeletionPortal={openAccountDeletionPortal}/></>}
    />
    <SettingsEditor functionForButton={closeSettingsModule} context={context} display={settingsEditorOpen}></SettingsEditor>
    <DeleteAccount display={deleteAccountOpen} functionForButton={closeAccountDeletionPortal}/>
    <InputModule functionForButton={handleClick} display={inputOpen ? 'flex' : 'none'}/>   
    <CustomPostModule loadedVoices={voices} display={customPostModuleOpen ? 'flex' : 'none'} functionForButton={handleClick2} />
    </>
}
    
export default BillingPage;